export const site = {
  name: "GP tax consulting s.r.o.",
  shortName: "GP tax consulting",
  legalName: "GP tax consulting s.r.o.",
  tagline: "Účetnictví, daně a mzdy s osobním přístupem",
  description:
    "Česká účetní a daňová kancelář pro OSVČ a malé i střední firmy. Vedeme účetnictví, daňové poradenství a zpracování mezd. Sídlo v Opavě.",
  url: "https://www.dane-a-ucetnictvi.eu",
  locale: "cs-CZ",
  brand: {
    logo: "/uploads/logo-gp-tax.png",
    logoAlt: "GP tax consulting – logo",
  },
  address: {
    street: "Sadová 121/4",
    city: "Opava",
    cityPart: "Předměstí",
    zip: "746 01",
    country: "CZ",
    countryName: "Česká republika",
  },
  company: {
    ico: "01988875",
    dic: "CZ01988875",
    legalForm: "Společnost s ručením omezeným",
    register: "C 57058 vedená u Krajského soudu v Ostravě",
    bankAccount: "2400465455/2010",
    dataBox: "59iy7m8",
  },
  contact: {
    phone: "+420 553 612 851",
    phoneHref: "+420553612851",
    email: "poradcegrafova@volny.cz",
    officeHours: "8–14 hod",
    officeHoursNote: "v pracovní dny",
  },
  mapUrl:
    "https://www.google.com/maps/search/?api=1&query=Sadov%C3%A1%20121%2F4%2C%20746%2001%20Opava",
} as const;

export type Site = typeof site;
